import {h} from 'preact'

export default () => <div class='animated-loader'>
    <div/>
    <div/>
    <div/>
</div>
